<template>
  <img
    class="dppl-png"
    :data-file-name="fileName"
    :src="src"
    :alt="fileName"
    v-bind="$attrs"
  />
</template>

<script setup>
import { computed } from 'vue';

const isUnitTests = import.meta.env.NODE_ENV === 'test';
const images = isUnitTests
  ? {}
  : import.meta.glob('@/assets/png/*.png', { eager: true, query: '?url', import: 'default' });

const props = defineProps({
  fileName: { type: String, default: '' },
});

const src = computed(() => images[`/src/assets/png/${props.fileName}.png`]);
</script>
